import { useState, useCallback, useEffect } from 'react';

const STORAGE_KEY = 'blockSearchTimestamps';
const WINDOW_MS = 60 * 60 * 1000;
const MAX_SEARCHES = 21;

const readTimestamps = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    if (!Array.isArray(arr)) return [];
    return arr.filter(t => typeof t === 'number');
  } catch (e) {
    return [];
  }
};

const writeTimestamps = (arr) => {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(arr)); } catch (e) {}
};

const pruneOld = (arr) => {
  const now = Date.now();
  return arr.filter(t => now - t < WINDOW_MS);
};

export const useSearchQuota = () => {
  const [stamps, setStamps] = useState(() => pruneOld(readTimestamps()));

  const refresh = useCallback(() => {
    setStamps(pruneOld(readTimestamps()));
  }, []);

  useEffect(() => {
    refresh();
    const interval = setInterval(refresh, 15_000);
    return () => clearInterval(interval);
  }, [refresh]);

  const consume = useCallback(() => {
    const pruned = pruneOld(readTimestamps());
    if (pruned.length >= MAX_SEARCHES) return false;
    pruned.push(Date.now());
    writeTimestamps(pruned);
    setStamps(pruned);
    return true;
  }, []);

  const count = stamps.length;
  const remaining = Math.max(0, MAX_SEARCHES - count);
  const limited = remaining === 0;
  const nextAvailableMs = limited && stamps.length > 0
    ? Math.max(0, Math.min(...stamps) + WINDOW_MS - Date.now())
    : 0;

  return { remaining, max: MAX_SEARCHES, limited, nextAvailableMs, consume };
};
